<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="10">
        <span class="red">*</span> 开启锁粉：
        <a-radio-group name="radioGroup" @change="onChange" v-model="lockStatus">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group>
      </a-col>
    </a-row>
    <a-row style="margin-top: 40px">
      <a-col :span="10">
        <span class="red">*</span> 锁粉方式：
        <a-radio-group name="radioGroup" @change="onChange" v-model="lockType">
          <a-radio :value="0">首次注册锁粉</a-radio>
          <a-radio :value="1">首次下单锁粉</a-radio>
        </a-radio-group>
      </a-col>
    </a-row>
    <a-button class="btn" type="primary" @click="setConnStatus">提交</a-button>
  </a-card>
</template>

<script>
export default {
  name: 'FansList',
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      lockId: 0,
      lockStatus: 0,//锁粉状态 0:关闭 1:开启
      lockType: 0//锁粉类型 0:首次注册锁定 1:首次下单锁定
    }
  },
  mounted() {
    this.getConnStatus()
  },
  methods: {
    onChange(e) {
      this.status = e.target.value
    },
    getConnStatus() {
      this.getHttpServices().getApiService().post('api/memberLock/getMemberLockSet')
        .then(res => {
          this.lockId = res.lockId
          this.lockStatus = res.lockStatus
          this.lockType = res.lockType
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    setConnStatus() {
      let parm = {
        lockMerchantId: this.merchantId,
        lockId: this.lockId,
        lockStatus: this.lockStatus,
        lockType: this.lockType
      }
      this.getHttpServices().getApiService().post('api/memberLock/updateMemberLockSet', parm)
        .then(res => {
          this.$message.success('设置成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped lang="less">
.hotelNav {
  border-left: 5px solid #009688;
  line-height: 50px;
  color: #333;
  font-size: 14px;
  padding-left: 20px;
  margin-bottom: 20px;
}

.red {
  display: inline-block;
  color: red;
  margin-left: 20px;
}

.btn {
  margin: 30px 0 0 110px;
}
</style>